import { css } from 'styled-components';
import { SiteButton, WithFontBody } from 'styles/commonCss';
import { mqSmallMax } from 'styled/tools/media-queries';

const formControlHeight = '35px';

export const Forms = css`
  a,
  button,
  select,
  textarea,
  input[type='text'],
  input[type='password'],
  input[type='datetime'],
  input[type='datetime-local'],
  input[type='date'],
  input[type='month'],
  input[type='time'],
  input[type='week'],
  input[type='number'],
  input[type='email'],
  input[type='url'],
  input[type='search'],
  input[type='tel'],
  input[type='color'] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    box-shadow: none;
    line-height: 1;
  }

  select,
  input[type='text'],
  input[type='password'],
  input[type='datetime'],
  input[type='datetime-local'],
  input[type='date'],
  input[type='month'],
  input[type='time'],
  input[type='week'],
  input[type='number'],
  input[type='email'],
  input[type='url'],
  input[type='search'],
  input[type='tel'],
  input[type='color'] {
    ${WithFontBody}
    @media ${mqSmallMax} {
      font-size: 16px !important;
    }
    background: var(--fill-bright);
    line-height: ${formControlHeight};
    height: ${formControlHeight};
    border-radius: 0;
    color: var(--text-primary);
  }

  textarea,
  input[type='text'],
  input[type='password'],
  input[type='datetime'],
  input[type='datetime-local'],
  input[type='date'],
  input[type='month'],
  input[type='time'],
  input[type='week'],
  input[type='number'],
  input[type='email'],
  input[type='url'],
  input[type='search'],
  input[type='tel'],
  input[type='color'] {
    border: 1px solid var(--outline-neutral);
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
    &::placeholder {
      text-transform: capitalize;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input::-webkit-calendar-picker-indicator {
    -webkit-appearance: none;
  }

  /* SELECT */
  .select-wrap {
    position: relative;
    display: block;
    width: 100%;
  }
  .select {
    position: relative;
    width: 100%;
    &:before {
      transform: translateY(-50%);
      position: absolute;
      top: 50%;
      right: 10px;
    }
    select {
      @media ${mqSmallMax} {
        font-size: 16px !important;
      }
      font-size: 14px;
      position: relative;
      cursor: pointer;
      width: 100%;
      background: transparent;
      text-indent: 0;
      padding: 0 20px 0 10px;
      border: 1px solid var(--outline-neutral);
      line-height: 1;
    }
  }

  /* COUNTER */
  .counter {
    position: relative;
    max-width: 120px;
    .field {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      line-height: 2rem;
      height: 2rem;

      /* Chrome, Safari, Edge, Opera */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      &:focus-visible {
        outline: rgb(28, 58, 19) solid 1px;
      }

      /* Firefox */
      &[type='number'] {
        -moz-appearance: textfield;
      }
    }
    .more,
    .less {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
      font-size: 12px;
      position: absolute;
      cursor: pointer;
      height: 2rem;
      width: 2rem;
      top: 0;
      * {
        fill: var(--fill-brand);
      }
    }
    .more {
      right: 0;
    }
    .less {
      left: 0;
    }
  }

  .singleLimitSubheader {
    display: flex;
    justify-content: center;
    font-size: 12px;
    padding-top: 10px;
    font-weight: 400;
    line-height: 1.5;
  }

  /* BUTTON */
  .button {
    ${SiteButton}

    &:focus:not(.loading):not(.disabled) {
      color: var(--fill-bright);
      background-color: #162e0f;
      border-color: var(--fill-bright);
      outline: solid 2px var(--fill-bright);
      outline-offset: 5px;
    }

    &.disabled {
      cursor: default;
      opacity: 0.5;
    }

    &.loading {
      cursor: default;
      opacity: 0.5;
    }

    &-tertiary {
      transition: all 0.25s ease;
      * {
        transition: all 0.25s ease;
        font-size: 12px;
        font-weight: 500;
      }
      span {
        line-height: 12px;
      }
      circle {
        fill: var(--fill-bright);
      }
      &:hover {
        circle {
          fill: var(--fill-brand) !important;
        }
        path,
        line {
          stroke: var(--fill-bright) !important;
        }
      }
    }

    &-outline-accent {
      color: var(--text-primary);
      background-color: transparent;
      &:focus:not(.loading):not(.disabled),
      &:hover:not(.loading):not(.disabled) {
        color: var(--fill-bright);
        background-color: var(--fill-brand);
        * {
          color: var(--fill-bright) !important;
        }
      }
      * {
        color: var(--text-primary);
      }
    }

    * {
      transition: all 0.25s ease;
      line-height: 1;
    }

    span {
      font-weight: 500;
    }
  }

  .modal-button {
    border: 0;
    margin-top: 30px;
    background: none;

    i {
      margin-right: 10px;
    }

    i:nth-child(1) {
      display: inline-block;
    }

    i:nth-child(2) {
      display: none;
    }

    * {
      vertical-align: middle;
    }
  }

  html.with-popup .modal-button {
    i:nth-child(1) {
      display: none;
    }

    i:nth-child(2) {
      display: inline-block;
    }
  }
`;
